import { DynamicRouteDataService } from './dynamic-route-data.service';

export const resolvers = [DynamicRouteDataService];

export * from './dynamic-route-data.service';
